import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("CorteVenta");
const crud = rpcCrudService<models.CorteVenta, models.CorteVentaDTO>(controller);

const otros = {

    /**
     * Genera un reporte de comisiones según los parametros
     * @param IdCorte 
     */
    GenerarReporteComisiones: async (IdCorte: number, IdVendedor: number | null): Promise<string> => await controller("GenerarReporteComisiones", { IdCorte, IdVendedor }),
    /**Genera el detalle del reporte de comisiones */
    GenerarReporteComisionDetalle: async (idCorte: number, idVendedor: number | null): Promise<string> => await controller("GenerarReporteComisionDetalle", { idCorte, idVendedor}),
}

export const CorteVenta = cacheResource({ ...crud, ...otros, },
    {
    },
    {}
)


// WEBPACK FOOTER //
// ./app/resources/items/corteventa.ts